import { render, staticRenderFns } from "./PackageLogo.vue?vue&type=template&id=00f1cfee&"
import script from "./PackageLogo.vue?vue&type=script&lang=js&"
export * from "./PackageLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports